import React,{useEffect} from 'react';
import { Flex, Box, Image, useColorMode, Text, Button, useMediaQuery } from "@chakra-ui/react";
import { motion } from 'framer-motion';
import developer from '../assets/developer.svg';
import { BiSolidDownload } from "react-icons/bi";
import { FaHireAHelper } from "react-icons/fa";
import resume from "../assets/HimanshuChoudhary_NITKKR.pdf";

const Home = () => {
  const { colorMode } = useColorMode();
  const [isSmallerScreen] = useMediaQuery("(max-width: 700px)");
  const gradientColor = `linear-gradient(135deg, #FF6B6B, #7873F5)`;

  const handleDownloadCV = () => {
    const link = document.createElement("a");
    link.href = resume;
    link.target = "_blank";
    link.download = "Himanshu.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleHireMe = () => {
    window.location.href = "mailto:himanshugoldy24@gmail.com?subject=Regarding Hiring&body=Hi, I'm interested in hiring you for a project.";
  };

  useEffect(()=>{
    window.scrollTo(0,0);
  })

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
    >
      <Flex
        direction={isSmallerScreen ? "column" : "row"}
        backgroundColor={colorMode === "light" ? "white" : "dark"}
        overflow="hidden"
      >
        <Box
          flex="100%"
          padding="20px"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          color={colorMode === "light" ? "black" : "white"}
          textAlign="center"
        >
          <motion.div
            animate={{
              translateY: "20px",
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "reverse",
            }}
          >
            <Flex direction="column">
              <Text fontFamily="Roboto sans-serif" fontSize="80px" fontWeight="bold" flexWrap="wrap" bgGradient={gradientColor}
              bgClip="text">
                Hi, I'm Himanshu
              </Text>
              <Text fontFamily="Roboto sans-serif" fontSize="25px" fontWeight="bold" marginBottom="1rem" flexWrap="wrap">
                Competitive Programmer | Full Stack Developer
              </Text>
              <Text fontStyle="italic" fontSize="20px" marginBottom="1rem" flexWrap="wrap" color={"gray.500"}>
                I craft versatile applications across web, mobile, and machines, with a knack for developing scalable software solutions and mastering competitive programming challenges.
              </Text>
              <Flex justifyContent="space-evenly">
                <Button
                  _hover={{ transform: "scale(1.1)" }}
                  colorScheme="purple"
                  mt="1rem"
                  leftIcon={<BiSolidDownload />}
                  onClick={handleDownloadCV}
                >
                  Download CV
                </Button>
                <Button
                  _hover={{ transform: "scale(1.1)" }}
                  colorScheme="purple"
                  mt="1rem"
                  leftIcon={<FaHireAHelper />}
                  onClick={handleHireMe}
                >
                  HIRE ME
                </Button>
              </Flex>
            </Flex>
          </motion.div>
        </Box>
        <Box
          flex="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginTop={isSmallerScreen ? "1rem" : "0"}
        >
          <Image src={developer} alt='Developer' />
        </Box>
      </Flex>
    </motion.div>
  );
};

export default Home;
